import localStorage from "store2";

export const pusherConfig = () => {
	return {
		client: {
			clientKey: import.meta.env.VITE_PUSHER_KEY,
			cluster: "ap1",
			authEndpoint: `${import.meta.env.VITE_HUB_URI}/pusher/auth`,
			auth: {
				params: {
					store: localStorage.get("storeId"),
					mode: "display",
				},
				headers: {},
			},
		},
	};
};
